import Hero from "../components/Hero/Hero";
import TopCategories from "../components/TopCategories/TopCategories";
import Features from "../components/Features/Features";
import Offers from "../components/Offers/Offers";
import Deal from "../components/Deal/Deal";
import TopProducts from "../components/TopProducts/TopProducts";
import Testimonials from "../components/Testimonials/Testimonials";

function Home({ wishlist, onAddToWishlist, onRemoveFromWishlist, onAddToCart }) {
  return (
    <>
      <Hero />
      <TopCategories />
      <Features />
      <Offers />
      <Deal />
      <TopProducts
        wishlist={wishlist}
        onAddToWishlist={onAddToWishlist}
        onRemoveFromWishlist={onRemoveFromWishlist}
        onAddToCart={onAddToCart}
      />
      <Testimonials />
    </>
  );
}

export default Home;
